<!--
 * @Author: TinaHuang0183 Tina.Huang@splashtop.com
 * @Date: 2022-08-26 16:11:40
 * @LastEditors: Tina Huang
 * @LastEditTime: 2022-12-22 18:11:17
 * @FilePath: /notion-widgets-site/src/views/Document.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="block">
    <el-collapse :value="['1']">
      <el-collapse-item title="Step 1: 创建专属组件" name="1">
        <p>
          1. 选择想要的组件进行创建<br />
          2. 设置自己想要的配置，背景颜色，字体颜色等<br />
          3. 点击右下角立即创建即复制对应的组件链接
        </p>
        <img :src="step1" />
      </el-collapse-item>
      <el-collapse-item title="Step 2: 在Notion内使用" name="2">
        <p>方式一：直接粘贴链接并选择「Create embed」</p>
        <img :src="notion[0]" />
        <p>方式二：输入「/embed」命令并选择，在「Embed link」内输入组件链接</p>
        <img :src="notion[1]" />
        <img :src="notion[2]" />
      </el-collapse-item>
      <el-collapse-item title="Step 3: 在FlowUs内使用" name="3">
        <p>方式一：直接粘贴链接并选择「转换为 嵌入网页」</p>
        <img :src="flowus[0]" />
        <p>方式二：输入「/embed」命令并选择「嵌入网页」，在输入框内内输入组件链接</p>
        <img :src="flowus[1]" />
        <img :src="flowus[2]" />
      </el-collapse-item>
      <el-collapse-item title="Step 4: 在Wolai内使用" name="4">
        <p>输入「/embed」命令并选择「嵌入内容」，在输入框内内输入组件链接</p>
        <img :src="wolai[0]" />
        <img :src="wolai[1]" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      step1: require("../assets/step1.gif"),
      notion: [
        require("../assets/notion_01.png"),
        require("../assets/notion_02.png"),
        require("../assets/notion_03.png"),
      ],
      flowus: [
        require("../assets/flowus_01.png"),
        require("../assets/flowus_02.png"),
        require("../assets/flowus_03.png"),
      ],
      wolai: [
        require("../assets/wolai_01.png"),
        require("../assets/wolai_02.png"),
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.block {
  padding: 0 30px;
}
img {
  width: 100%;
  display: block;
  margin: 10px 0;
}
p {
  font-size: 16px;
}
</style>
